import React from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "react-intl";
import StripeCheckout from "react-stripe-checkout";
import Spinner from "react-spinkit";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";
import { InputFloatingLabel, Select, ImageUploadCustom } from "../../formik";
import countryOptions from "../../helpers/countries";
import Actions from "../../redux/actions";
import * as Yup from "yup";
import Alert from "react-s-alert";
import editPasswordModal from "../EditPasswordModal";
import ProfileTable from './proifle-table';

import AddCreditsPopup from './add-credits-popup';
import SimulatorPopup from './simulator-popup'; 

const Profile = ({ intl, user, dispatch, transactions, setShow }) => {
  const {
    level,
    free_user,
    credits,
    stripe_setup,
    disabled,
    _id,
    stripe_info,
    created,
    plan,
    free,
    ...initialValues
  } = user.profile;

  const [syncingWithServer, setSyncingWithServer] = React.useState(false);

  const [showAddCreds, setShowAddCreds] = React.useState(false);
  const [showSimulator , setShowSimulator] = React.useState(false);

  const onToken = (token) => {
    setSyncingWithServer(true);
    dispatch(Actions.userStripe({ stripe_info: token }))
      .then((resp) => Alert.success(intl.formatMessage({ id: resp.message })))
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  };

  const updateUser = (user) => {
    Alert.warning("Updating your account");
    dispatch(Actions.userUpdate(user))
      .then((resp) => {
        Alert.success(intl.formatMessage({ id: resp.message }));
      })
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  };

  return (
    <div className="pad-2rem profile-bg">
      <Container fluid>
        <Row>
          <Col>
            <p className="profile-sub-header">
              Espace personnel et transactions
            </p>
          </Col>
        </Row>
        <Row className="m-t-40">
          <Col md={4}>
            <div className="profile-stack">
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                  mobile: Yup.number().min(10),
                })}
                onSubmit={(values) => {
                  const { email, updatedAt, createdAt, stripe_customer_id, ...rest } = values;
                  console.log(values);
                  updateUser(rest);
                }}
                render={({ values, setFieldValue }) => (
                  <Form className="floating-label-form">
                    {/* <pre>{JSON.stringify(initialValues, null, 2)}</pre> */}
                    <div className="fields-container">
                      <div className="profile-upload">
                        <Field
                          component={ImageUploadCustom}
                          id="photo"
                          defaultImage="/images/profile-ico-img.png"
                          name="photo"
                          accept="image/*"
                          buttonEmpty="label.uploadPhoto"
                          buttonUploaded={intl.formatMessage({
                            id: "label.photoUploaded",
                          })}
                          maxSize={process.env.REACT_APP_IMAGE_FILE_SIZE_MAX}
                        />
                      </div>
                      <Row className="align-items-center m-t-30 m-b-30 log-container">
                        <Col>
                          <div className="credits-log">
                            <span className="creds">
                              {user.profile.credits}
                            </span>
                            <FormattedMessage id="user.creds" />{user.profile.credits > 2 ? 's' : ''}
                            <img
                              className="m-l-20"
                              src="/images/creds.png"
                              alt="cred img"
                            />
                          </div>
                        </Col>
                        <Col className="text-right">
                          <div className="relative ib">
                            <Button onClick={() => setShowAddCreds(!showAddCreds)} className="add-credits">
                              <img alt="" src="/icons/btn-plus.png" />
                            </Button>
                            {
                              showAddCreds && <AddCreditsPopup setShowAddCreds={setShowAddCreds} intl={intl} />
                            }
                          </div>
                          {/* Show simulator modal */}
                          <div className="relative ib">
                            <Button onClick={() => setShowSimulator(!showSimulator)} className="help">
                              <img alt="" src="/icons/help-ico.png" />
                            </Button>
                            {
                              showSimulator && <SimulatorPopup setShowSimulator={setShowSimulator} intl={intl}  />
                            }
                          </div>
                        </Col>
                      </Row>
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.firstname",
                        })}
                        label={intl.formatMessage({
                          id: "input.firstname",
                        })}
                        name="firstName"
                        id="firstname"
                        required
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.lastname",
                        })}
                        label={intl.formatMessage({
                          id: "input.lastname",
                        })}
                        name="lastName"
                        id="lastname"
                        required
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.address",
                        })}
                        label={intl.formatMessage({
                          id: "input.address",
                        })}
                        required
                        id="address"
                        name="address"
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.phone",
                        })}
                        label={intl.formatMessage({
                          id: "input.phone",
                        })}
                        name="phone"
                        id="phone"
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.mobile",
                        })}
                        label={intl.formatMessage({
                          id: "input.mobile",
                        })}
                        name="mobile"
                        required
                        id="mobile"
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="email"
                        placeholder={intl.formatMessage({
                          id: "input.email",
                        })}
                        label={intl.formatMessage({
                          id: "input.email",
                        })}
                        name="email"
                        disabled
                        id="email"
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.city",
                        })}
                        label={intl.formatMessage({
                          id: "input.city",
                        })}
                        required
                        name="city"
                        id="city"
                      />
                      <Field
                        type="text"
                        component={InputFloatingLabel}
                        placeholder={intl.formatMessage({
                          id: "input.zipcode",
                        })}
                        label={intl.formatMessage({
                          id: "input.zipcode",
                        })}
                        required
                        name="zipcode"
                        id="zipcode"
                      />
                      <Field
                        component={Select}
                        name="country"
                        required
                        options={countryOptions}
                      />
                      <Button
                        type="button"
                        onClick={() => {
                          setShow(false);
                          editPasswordModal(intl, user, dispatch, setShow);
                        }}
                        variant="default"
                      >
                        <FormattedMessage id="button.changePassword" />
                      </Button>
                      <Row className="m-t-20">
                        <Col>
                          <p className="text-uppercase lt-gr-text">
                            Annuler les modifications
                          </p>
                        </Col>
                        <Col>
                          <p className="text-primary text-right">
                            *Champs obligatoires
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <Button
                      className="font-common-13 btn-custom"
                      type="submit"
                      block
                    >
                      {intl.formatMessage({
                        id: "link.profile-update",
                      })}
                    </Button>
                  </Form>
                )}
              />
            </div>
          </Col>
          <Col md={8}>
            <h2 className="m-t-40 header-grey-text">Transactions</h2>
            {user.profile.address ? (
              user.profile.stripe_setup ? (
                <StripeCheckout
                  name="eSlides"
                  panelLabel="Link your credit card"
                  token={onToken}
                  email={user.profile.email}
                  stripeKey={process.env.REACT_APP_STRIPE_KEY}
                >
                  <Button className="btn-transaction">
                    <FormattedMessage id="button.changePayment" />
                  </Button>
                </StripeCheckout>
              ) : (
                <div>
                  {/* <Alert variant="warning">
                      <FormattedMessage id="label.noPayment" />
                    </Alert> */}
                  {syncingWithServer ? (
                    <Spinner
                      spinnerName="wave"
                      style={{ display: "inline-block" }}
                    />
                  ) : (
                    <StripeCheckout
                      name="eSlides"
                      panelLabel="Link your credit card"
                      token={onToken}
                      email={user.profile.email}
                      stripeKey={process.env.REACT_APP_STRIPE_KEY}
                    >
                      <Button className="btn-transaction">
                        <FormattedMessage id="button.addPayment" />
                      </Button>
                    </StripeCheckout>
                  )}
                </div>
              )
            ) : (
              ""
            )}
            <div className="profile-table m-t-20">
              <ProfileTable intl={intl} transactions={transactions} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  transactions: state.user.transactions,
});

export default connect(mapStateToProps)(injectIntl(Profile));
